var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AeTextareaFormatted',_vm._g(_vm._b({staticClass:"ae-input-mnemonic",attrs:{"header":_vm.$t('recover.mnemonic'),"rows":"3","submit-on-enter":"","value":_vm.value,"autocorrect":"off","autocapitalize":"off"}},'AeTextareaFormatted',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }